<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入发货编号" isRetain ref="ScanQuery">
      <el-button type="primary" @click="restHandle">重置</el-button>
      <span class="receiverNation" v-if="receiverNation">收货国家:{{ receiverNation }}</span>
      <template v-if="customerTagNameList?.length">
        <div class="publicCustomerTagName" v-for="item in customerTagNameList" :key="item">{{ item }}</div>
      </template>
      <div slot="customize">
        <div class="flex">
          <div style="text-align: left;">
            <span style="font-size: 20px;font-weight: 700;color:#d93838" v-if="customerShopName">客户店铺名称:{{
              customerShopName
              }}</span>
            <span style="font-size: 20px;margin: 0 20px;font-weight: 700" v-if="receiveHouse">Ship
              To:{{ receiveHouse }}</span>
          </div>
          <div class="flex">
            <el-button type="primary" style="margin: 4px 4px" @click="downMark" v-if="boxMarkLink">下载箱唛</el-button>
            <el-button type="primary" style="margin: 4px 4px" @click="fillBox">开始 / 修改装箱</el-button>
            <el-button type="success" style="margin: 4px 4px" @click="toFinish">打包完成</el-button>
          </div>
        </div>
      </div>
    </ScanQuery>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单证备注信息</span>
      </div>
      <div style="text-align: left">
        备注内容：<span style="color:red;font-size: 26px">{{ auditRemark || '-' }}</span>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>附加项信息</span>
      </div>
      <WmsTable :columns="columnsAddition" :hasHeader="false" :is-pagination="false" :dataSource="additions">
        <div slot="image" slot-scope="{text}">
          <ImgPreviews :images="text.split(',')" width="60" height="60" v-if="text" />
        </div>
        <div slot="operand" slot-scope="{text, record}">
          <el-input-number v-model="record.operand" :min="0" :step-strictly="true"
            @blur="operandChanged($event, record)" :controls="false"
            :disabled="!record.operandModifiable"></el-input-number>
        </div>
      </WmsTable>
    </el-card>
    <el-card class="box-card" v-if="extendDTO && (extendDTO.managerRemark || extendDTO.managerRemarkImgs)">
      <div slot="header" class="clearfix">
        <span>担当备注信息</span>
      </div>
      <div style="text-align:left" class="managerRemark">
        <div>担当名: {{ extendDTO.managerRemarkOperator }}</div>
        <div>备注内容: {{ extendDTO.managerRemark }}</div>
        <div v-if="extendDTO.managerRemarkImgs">图片:
          <ImgView v-for="i, index in extendDTO.managerRemarkImgs.split(',')" :src="i" :key="index" />
        </div>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="margin-right: 10px">发货信息</span>
        <el-tag v-if="deliveryType" style="margin-right: auto">{{ deliveryTitle }}</el-tag>
        <span style="padding: 0 20px"> 当前商品种类数量： {{ productSkuAll.length }} 种; 总共需要： {{ totalAmount }} 个; </span>
        <!-- <div class="action__ul--btn" v-if="!!needBoxMark">
          <el-button type="success" style="margin: 0 10px" @click="downMark">下载箱唛文件</el-button>
        </div> -->
        <!-- <div class="action__ul--btn"><span>托盘数量：</span>
          <IptNumber v-model="inventoryAmount" unit="个" />
        </div> -->
      </div>
      <el-empty :image-size="100" v-if="!shipInfo" />
      <el-descriptions :column="2" border v-else>
        <el-descriptions-item label="客户名称">
          {{ shipInfo.customerName }}
        </el-descriptions-item>
        <el-descriptions-item label="快递公司">
          {{ shipInfo.wmsForwarder }}
        </el-descriptions-item>
        <el-descriptions-item label="发货件数">
          {{ shipInfo.deliveryNums }}
        </el-descriptions-item>
        <el-descriptions-item label="发货名称">
          {{ shipInfo.deliveryTitle }}
        </el-descriptions-item>
        <el-descriptions-item label="收件地址">
          <!-- <span v-for="(item, index) in shipInfo.deliveryTaskAddressList" :key="index" v-if="item.addressType == 0">{{
              item.nation
          }}{{ item.name }}{{ item.mobile }}{{ item.postalCode }}{{ item.province }}{{ item.area }}{{ item.address }}</span> -->


          <div>收件人：{{ shipInfo.receiptAddressDetail.name }}</div>
          <div>电话：{{ shipInfo.receiptAddressDetail.mobile }}</div>
          <div>地址：{{ shipInfo.receiptAddressDetail.address }}</div>
          <div>邮编：{{ shipInfo.receiptAddressDetail.postalCode }}</div>
          <div>国家:{{ shipInfo.receiptAddressDetail.nation }}</div>
          <div>省:{{ shipInfo.receiptAddressDetail.province }}</div>
          <div>县：{{ shipInfo.receiptAddressDetail.area }}</div>
          <div>城市/街道：{{ shipInfo.receiptAddressDetail.city }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="快递单号">
          <span v-for="(item, index) in expressList" :key="index">{{ item.logisticsCode }} </span>
        </el-descriptions-item>
        <el-descriptions-item label="清关地址" :span="2">
          <!-- {{ shipInfo.customsClearanceAddress }} -->

          <div>收件人：{{ shipInfo.customsClearanceAddressDetail.name }}</div>
          <div>电话：{{ shipInfo.customsClearanceAddressDetail.mobile }}</div>
          <div>地址：{{ shipInfo.customsClearanceAddressDetail.address }}</div>
          <div>邮编：{{ shipInfo.customsClearanceAddressDetail.postalCode }}</div>
          <div>国家:{{ shipInfo.customsClearanceAddressDetail.nation }}</div>
          <div>省:{{ shipInfo.customsClearanceAddressDetail.province }}</div>
          <div>县：{{ shipInfo.customsClearanceAddressDetail.area }}</div>
          <div>城市/街道：{{ shipInfo.customsClearanceAddressDetail.city }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <WmsTable :columns="columns" :dataSource="dataSourceCall" :is-pagination="false" :rowClassFunc="rowClassFunc">
      <template slot="productImgAction" slot-scope="{ text, record, index }">
        <el-image style="width: 60px; height: 60px" :src="text" :preview-src-list="[text]"> </el-image>
      </template>
      <template slot="amountAction" slot-scope="{ text, record, index }">
        <span style="font-weight: 600">
          <span
            :class="(packedSku[record.shopProductSku] ? packedSku[record.shopProductSku] : record.inNums) == record.deliveryNums ? '' : 'warningText'">{{
              packedSku[record.shopProductSku] ? packedSku[record.shopProductSku] :
                record.inNums || 0
            }}</span>/
          <span style="padding-right: 4px">{{ record.deliveryNums }}</span>
        </span>
      </template>
    </WmsTable>
    <ContainerList ref="containerList" @containerChange="containerChangeCall" @getLogistics="getLogistics"
      @close="queryCall({ code: deliveryTaskCode })" />
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import IptNumberBtn from "@/components/IptNumberBtn";
import IptNumber from "@/components/IptNumber";
import ImgView from "@/components/ImgView";
import ImgPreviews from "@/components/ImgPreviews";
import { columns } from "@/views/outOfStock/FBABagPackage/data";
import { audioPay } from "@/utils/tools";
import ContainerList from "@/views/outOfStock/FBABagPackage/components/ContainerList";
import { finishBuildBag, taskCodeGetInfo, getLogisticsInfoList, getLogisticsNo, editOperand, packFinishConfirm } from "@/apis/outStock";
export default {
  name: "FBABagPackage", // 大件装箱
  components: {
    ScanQuery,
    WmsTable,
    IptNumber,
    IptNumberBtn,
    ContainerList,
    ImgView,
    ImgPreviews
  },
  provide: function () {
    return {
      productSkuAll: () => this.productSkuAll,
      productSkuAll_shop: () => this.productSkuAll_shop,
      reDetail: this.reDetail,
      getdeliveryType: () => { return this.deliveryType },
      inNumsList: () => {
        let inNumsList = {}
        this.dataSource.forEach(item => {
          inNumsList[item.shopProductSku] = {
            deliveryNums: item.deliveryNums,
            inNums: this.packedSku[item.shopProductSku] ? this.packedSku[item.shopProductSku] : item.inNums
          }
        })
        console.log(inNumsList)
        return inNumsList
      }
    };
  },
  data() {
    return {
      query: {
        code: "",
      },
      receiveHouse: '',
      shipInfo: null,
      columns,
      dataSource: [],
      additions: [],
      // 箱唛打印
      boxMarkLink: "", // 下载地址
      needBoxMark: 0, // 0 不需要， 1 需要
      deliveryType: undefined, // 发货类型(0:大件普通 1:大件fba 2:小件 3:次品退货 4:异常退货 5:仓库调拨)
      inventoryAmount: 0,
      packedSku: {},
      deliveryTaskCode: "",
      customerShopName: '',
      auditRemark: '',
      expressList: [],
      columnsAddition: [
        { title: '附加项名称', key: 'additionName', dataIndex: 'additionName' },
        { title: '辅料名称', key: 'ingredientsName', dataIndex: 'ingredientsName' },
        {
          title: '辅料图片', key: 'image', dataIndex: 'image',
          scopedSlots: {
            customRender: "image",
          },
        },
        { title: '辅料SKU', key: 'ingredientsSku', dataIndex: 'ingredientsSku' },
        {
          title: '实际操作数量', key: 'operand', dataIndex: 'operand',
          scopedSlots: {
            customRender: "operand",
          },
        },
      ],
      receiverNation: '',
      auditRemark: "",
      extendDTO: '',
      customerTagNameList: []
    };
  },
  computed: {
    // 用于判断扫描的商品是否属于该发货单的
    productSkuAll: function () {
      return [...this.dataSource.map((item) => [item.shopProductSku, item.amazonFnsku, item.amazonMsku])].flat()
    },
    productSkuAll_shop: function () {
      let productSkuAll_shop = {}
      this.dataSource.forEach((item) => {
        productSkuAll_shop[item.shopProductSku] = [item.shopProductSku, item.amazonFnsku, item.amazonMsku]
        // return {
        //   [item.shopProductSku]: [item.shopProductSku, item.amazonFnsku, item.amazonMsku]
        // }
      })
      return productSkuAll_shop
    },
    totalAmount: function () {
      return this.dataSource.reduce((pre, item) => pre + item.deliveryNums, 0);
    },
    deliveryTitle: function () {
      return ['大件FBA', '大件普通', '小件', '次品退货', '异常退货', '仓库调拨'][this.deliveryType]
    },
    dataSourceCall: function () {
      return this.dataSource.map(v => {
        return {
          ...v,
          warningColumns: ((this.packedSku[v.shopProductSku] ? this.packedSku[v.shopProductSku] : v.inNums) == v.deliveryNums) ? '' : 'warningColumns'
        }
      }).sort((v1, v2) => {
        if (v1.warningColumns && !v2.warningColumns) {
          return -1
        }
        if (v2.warningColumns && !v1.warningColumns) {
          return 1
        }
        return 0
      })
    }
  },
  watch: {
    packedSku: {
      handler: function (newVal) {
        this.dataSource = this.dataSource
      }
    }
  },
  methods: {
    queryCall: function (payload) {
      const { code } = payload;
      this.query = {
        code: code.trim(),
      };
      this.getDetails();
      this.getExpressList();
    },
    restHandle: function () {
      this.query = {
        code: "",
      };
      this.shipInfo = null;
      this.dataSource = [];
      this.boxMarkAmount = 0;
      this.inventoryAmount = 0;
      this.receiverNation = ''
      this.customerTagNameList = []
      this.$refs["containerList"].clean();
    },
    reDetail() {
      this.getDetails()
    },
    getDetails: function () {
      const that = this;
      const params = {
        deliveryTaskCode: that.query.code,
        deliveryStatus: 3,
      };
      taskCodeGetInfo(params).then(({ code, data }) => {
        if (code === 0) {
          if (!!data) {
            if (data.deliveryType != 0 && new Date(data.endConfirmTime).getTime() > 1701680400000) {
              that.$message.warning('请前往大件装箱扫描')
              that.query.code = ''
              that.$refs.ScanQuery.rest()
              return
            }
            audioPay(`扫描成功`);
            that.deliveryTaskCode = params.deliveryTaskCode;
            const { deliveryTaskAdditionalDetailList = [], boxMarkLink = "", needBoxMark = 0, taskDetailList = [], deliveryType, customerShopName, auditRemark, receiverNation, extendDTO, customerTagNameList } = data;
            that.customerShopName = customerShopName
            that.boxMarkLink = boxMarkLink;
            that.needBoxMark = needBoxMark;
            that.dataSource = taskDetailList;
            that.deliveryType = deliveryType;
            that.additions = deliveryTaskAdditionalDetailList;
            that.createShipInfo(data);
            that.receiveHouse = taskDetailList[0].receiveHouse;
            that.receiverNation = receiverNation
            that.auditRemark = auditRemark
            that.extendDTO = extendDTO
            that.customerTagNameList = customerTagNameList
          }
          //重置数量
          this.packedSku = {};
        }
      });
    },
    createShipInfo: function (data) {
      const {
        deliveryTaskAddressList = [], // 发货任务-地址信息 根据类型判断 deliveryTaskAddressList[*].addressType 类型(0:收件人地址 1:英文收货地址 2:英文清关地址 3:发件人地址)
        deliveryNums, // 发货总数
        customerName, // 客户姓名
        deliveryTitle, // 	发货标题
        deliveryType, // 	发货类型(0:大件普通 1:大件fba 2:小件单品 3:小件多品 4:次品退货 5:异常退货 6:仓库调拨)
        forwarder, // 承运商
      } = data;
      let customsClearanceAddress = "";
      let receiptAddress = "";
      let customsClearanceAddressDetail = ''
      let receiptAddressDetail = ''
      if (deliveryTaskAddressList) {
        deliveryTaskAddressList.forEach((item, index) => {
          const { name = "--", nation = "--", mobile = "--", clubCode = "--", province = "--", city = "--", area = "--", address = "--" } = item;
          const _addressInfo = `收件人：${name},\n国家：${nation},\n省/州：${province},\n城市：${city},\n区/县${area}, \n街道：${address}`;
          if (item.addressType === 0) {
            receiptAddress = _addressInfo;
            receiptAddressDetail = item
          } else if (item.addressType === 2) {
            customsClearanceAddress = _addressInfo;
            customsClearanceAddressDetail = item
          }
        });
      }
      this.shipInfo = {
        customsClearanceAddress, // 清关地址
        customsClearanceAddressDetail,
        customerName, // 客户名称
        deliveryTitle, // 商品名称
        receiptAddress: "", // 收件地址
        receiptAddressDetail: receiptAddressDetail,
        forwarder, // 承运商
        deliveryNums, // 数量,
        deliveryTaskAddressList
      };
    },
    fillBox: function () {
      const that = this;
      this.$refs["containerList"].open({
        deliveryTaskCode: that.deliveryTaskCode,
      });
    },
    containerChangeCall: function (payload) {
      this.packedSku = payload;
    },
    toFinish() {
      const that = this
      packFinishConfirm({
        deliveryTaskCode: that.query.code
      }).then(res => {
        console.log(res)
        that.$confirm(res.data.reduce((res, target) => {
          return res += `<div class="additionTipsBox"><div class="additionTipsBox_XY">${target.additionName}</div><div>${target.operand}</div></div>`
        }, '<div class="additionTipsBox additionTipsBox_top"><div class="additionTipsBox_XY">附加项名称</div><div>附加项数量</div></div>'), '请确认以下附加项是否操作', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          customClass: "additionTipsBoxConfirm"
        }).then(() => {
          nextStep()
        })
      })
      return

      function nextStep() {
        const checkAll = that.dataSourceCall.reduce((pre, item) => {
          return pre + item.deliveryNums - (that.packedSku[item.shopProductSku] ? that.packedSku[item.shopProductSku] : item.inNums || 0)
        }, 0)
        if (checkAll > 0) {
          that.$confirm(`当前发货单商品未全部装箱，请确认是否打包完成`, "提示", {
            confirmButtonText: "确认",
            type: "error",
            cancelButtonText: "取消",
          }).then(() => {
            that.finishH()
          });
          return
        }
        that.finishH()
      }
    },
    finishH: function () {
      const that = this;
      finishBuildBag({ deliveryTaskCode: that.query.code, trayNums: that.inventoryAmount }).then(({ code, data }) => {
        if (code === 0) {
          if (data.needNotice) {
            that.$confirm(data.message, "提示", {
              confirmButtonText: "确认",
              type: "warning",
              cancelButtonText: "取消",
            })
            that.getDetails();
          } else {
            that.$message.success("打包完成");
          }
          that.restHandle();
        }
      });
    },
    downMark: function () {
      /*      区分发货单类型为FBA发货、非FBA发货
      1.”非FBA发货“类型的发货单
        此按钮，根据该发货单，用户在前端创建时，是否选择了“打印箱唛”附加项，
        若未选择，则在“大件装箱”界面展示时，无需展示”下载箱唛文件“按钮
        若选择，则在“大件装箱”界面展示“下载箱唛文件”按钮
      2.“FBA发货”类型的发货单（必选项）
        与当前SCM系统内打印箱唛功能保持一致，在发货单上操作上传、下载、打印箱唛*/
      // window.open('http://theckbstest-oss.theckbs.com/client/ebd7cf416c8.xls');
      window.open(this.boxMarkLink);
    },
    //获取物流单号
    getExpressList() {
      getLogisticsInfoList({
        deliveryTaskCode: this.query.code,
      }).then((res) => {
        const { code, data = [] } = res;
        if (code == 0) {
          this.expressList = data;
        }
      });
    },
    getLogistics() {
      getLogisticsNo({
        deliveryTaskCode: this.query.code,
      }).then((res) => {
        const { code, data = [] } = res;
        if (code == 0) {
          this.$message.success('成功')
          this.getDetails()
          this.getExpressList();
          this.$refs.containerList.getContainerDetail()
        }
      });
    },
    rowClassFunc(record) {
      return record.warningColumns
    },
    operandChanged(e, addition) {
      console.log(e, e.target.value)
      const operand = e.target.value
      editOperand({
        operand,
        deliveryTaskCode: addition.deliveryTaskCode,
        additionCode: addition.additionCode
      }).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.$message.success('修改成功')
        }
      }).finally(() => {
        this.queryCall({
          code: addition.deliveryTaskCode
        })
      })
    }
  },
};
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.action__ul--btn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.warningText {
  color: red
}

.receiverNation {
  font-size: 24px;
  font-weight: 600;
  margin-left: 10px;
}

.managerRemark div {
  margin: 10px 0;
  display: flex;
}

.managerRemark .img__div--view {
  margin-right: 20px;
}
</style>
<style>
.warningColumns td {
  background-color: #fdf5e6 !important
}

.additionTipsBox {
  display: flex;
  width: 560px;
}

.additionTipsBox div {
  display: flex;
  align-items: center;
  width: 50%;
  border-bottom: 1px solid;
  border-right: 1px solid;
  box-sizing: border-box;
  padding: 0 10px;
}

.additionTipsBox_XY {
  border-left: 1px solid;
}

.additionTipsBox_top {
  border-top: 1px solid;
}

.additionTipsBoxConfirm {
  width: 620px;
}
</style>